import { useTranslation } from 'react-i18next';

import { StatCard } from './StatCard.jsx';
import { RatingStatCard } from './RatingStatCard.jsx';
import { useReportsOverview } from '../data';
import styles from './SummaryLayout.module.css';

export const Overview = ({ campaignId }) => {
  const { t } = useTranslation('reports');

  const {
    data = {
      data: {
        peopleVisited: 0,
        totalVisits: 0,
        avgTileViews: 0,
      },
    },
    isLoading,
  } = useReportsOverview({ campaignId });
  const {
    data: { peopleVisited, totalVisits, avgTileViews },
  } = data;

  return (
    <div className={styles.statGrid}>
      <StatCard
        title={t('overview.uniqueVisits')}
        icon="fa-regular fa-users"
        value={peopleVisited}
        tooltip={t('overview.uniqueVisitsTooltip')}
        description={t('summary.statCards.uniqueVisitsDesc')}
        loading={isLoading}
      />
      <StatCard
        title={t('overview.totalVisits')}
        icon="fa-regular fa-eye"
        value={totalVisits}
        tooltip={t('overview.totalVisitsTooltip')}
        description={t('summary.statCards.totalVisitsDesc')}
        loading={isLoading}
      />
      <StatCard
        title={t('overview.averageTileViews')}
        icon="fa-regular fa-layer-group"
        value={avgTileViews}
        tooltip={t('overview.averageTileViewsTooltip')}
        description={t('summary.statCards.avgTileViewsDesc')}
        loading={isLoading}
      />
      <RatingStatCard campaignId={campaignId} />
    </div>
  );
};
